<template>
  <div class="opt-serve">
    <div class="serve-name">{{ goodName }}</div>
    <div class="price">¥{{ ruleForm.salePrice }}</div>
    <div class="num">
      <el-input-number size="small" v-model="ruleForm.Qty" :min="1" :max="10" />
    </div>
    <div>
      <el-button size="small" plain class="remove" @click="removeGoodsClick(ruleForm.goodId, ruleForm.paraId)"
        type="danger">删除
      </el-button>
    </div>

  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'

export default defineComponent({
  props: {
    ruleForm: {
      type: Object,
      default() {
        return {}
      }
    },
    goodName: {
      type: String,
      default: ''
    }
  },
  components: {

  },
  emits: ['removeGoodsClick'],
  setup(props, { emit }) {

    const removeGoodsClick = (goodId, paraId) => {
      emit('removeGoodsClick', goodId)
    }

    return {
      removeGoodsClick
    }

  }
})
</script>

<style scoped lang="less">
.opt-serve {
  display: flex;
  align-items: center;
  margin: 10px 0;
  padding: 0 10px;
  font-size: 12px;

  .num {
    flex: 2;
  }

  div {
    flex: 1;
    padding-left: 6px;
  }

  .remove {
    cursor: pointer;
  }
}
</style>




